import { z } from "zod";

// Email validation using zod
export const emailSchema = z.string().email();

export const isEmail = (value: string): boolean => {
  return emailSchema.safeParse(value).success;
};

// Numeric validation using zod
export const numericSchema = z.preprocess((val) => {
  if (val === "") return undefined;
  // Reject strings that contain any whitespace
  if (typeof val === "string" && /\s/.test(val)) {
    return NaN;
  }
  return val;
}, z.coerce.number());

export const isNumeric = (value: string): boolean => {
  return numericSchema.safeParse(value).success;
};
